import script from "./SolarSolution.vue?vue&type=script&setup=true&lang=js"
export * from "./SolarSolution.vue?vue&type=script&setup=true&lang=js"

import "./SolarSolution.vue?vue&type=style&index=0&id=4aea53c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aea53c3"]])

export default __exports__